module.exports = __webpack_public_path__ + "c60fa7ded3aa3f2c730d85b58dc7f5e6.png";